import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk'
import { SignOffsToolState } from '~/st-doc-viewer/annotations'

export function signOffsPlugin(): AnnotationPlugin<StampAnnotation, SignOffsToolState> {
  return {
    name: 'sign_offs',
    initialToolState: { name: 'sign_offs' }
  }
}
